module.exports = require("./ru-UA.js");